/*
 *
 * RegisterCaregiver actions
 *
 */

import { createAction } from 'redux-saga-actions';

// create action
const registerAction = createAction('app/RegisterCaregiver/REGISTER_CAREGIVER');
export default registerAction;

